/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
}
export function useReceberPropostaVendasDetalhe(props: Props) {
  const LISTAR_PROPOSTA_DETALHE = `${backofficeEnviroment}/common/oportunidades-lead/consultar-oportunidade/v1/${props.idOportunidade}`;
  const fetchData = async () => {
    const response = await instance.get(LISTAR_PROPOSTA_DETALHE);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["proposta-vendas-detalhe"],
    refetchOnWindowFocus: false,
  });
  return query;
}
